import { type ReactNode, useMemo, useState } from 'react';
import type { TodoWidgetDate } from '../../../../types';
import { TodosWidgetContext } from '../TodosWidgetContext';

type TodosWidgetProviderProperties = {
  children: ReactNode;
};

const TodosWidgetProvider = ({ children }: TodosWidgetProviderProperties) => {
  const [activeKey, setActiveKey] = useState<TodoWidgetDate>('today');
  const value = useMemo(() => ({ activeKey, setActiveKey }), [activeKey]);

  return <TodosWidgetContext.Provider value={value}>{children}</TodosWidgetContext.Provider>;
};

export default TodosWidgetProvider;
